import { Label } from '@/design-system/label';
import { Translation } from '@/hoslog-intl';
import CameraIcon from '@/icons/camera-icon';
import { cn } from '@/lib/utils';

type ImagePreviewProps = {
  imageSrc: string;
  alt: string;
  className?: string;
  isRequired?: boolean;
  imageClassName?: string;
  documentImageClassName?: string;
  variant?: 'circle' | 'rect' | 'document';
  label?: string;
  cancelClickHandler: () => void;
};
const getFileNameFromUrl = (url: string) => {
  try {
    return decodeURIComponent(url.split('/').pop() ?? '');
  } catch {
    return '';
  }
};

const ImagePreview = (props: ImagePreviewProps) => {
  const {
    imageSrc,
    className = '',
    imageClassName,
    documentImageClassName,
    variant = 'rect',
    alt,
    label,
    isRequired = false,
    cancelClickHandler,
  } = props;
  return (
    <div className={cn('flex flex-col justify-between min-h-[148px]', className)}>
      {label && (
        <Label className="font-bold ">
          <Translation id={label} />
          {isRequired && <span className="text-destructive-text leading-[100%]">*</span>}
        </Label>
      )}
      <div className={`mt-1 ${variant === 'circle' ? 'rounded-full w-[164px]' : ''}`}>
        {variant === 'document' ? (
          <div
            className={`${documentImageClassName} relative flex items-center gap-4 border border-dashed overflow-hidden border-border-strong rounded-md p-4 w-full`}
          >
            <div className="relative w-20 flex-shrink-0">
              <img src={imageSrc} alt={alt} className={`w-[88px] h-[88px] object-cover rounded-sm border`} />
              <button
                type="button"
                onClick={cancelClickHandler}
                className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-error-emphasis text-on-color text-xs flex items-center justify-center"
              >
                ✕
              </button>
            </div>
            <span className="text-sm font-medium text-foreground-heading truncate">{getFileNameFromUrl(imageSrc)}</span>
          </div>
        ) : (
          <div className="relative">
            <img
              src={imageSrc}
              alt={alt}
              className={cn(
                'w-[164px] h-[164px] object-cover',
                ` ${imageClassName}  ${variant === 'circle' ? 'rounded-full' : ''}`,
              )}
            />

            {variant === 'circle' ? (
              <CameraIcon
                onClick={cancelClickHandler}
                className={`rounded-full cursor-pointer text-on-color absolute right-2 top-30`}
              />
            ) : (
              <button
                type="button"
                onClick={cancelClickHandler}
                className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-error-emphasis text-on-color text-xs flex items-center justify-center"
              >
                ✕
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagePreview;
